export const API_URL = 'https://banca-aletti-26-api-574969884775.europe-west1.run.app/';
export const TOOLPRESS_API = "https://api-tool-press-yn26wrnl4q-ey.a.run.app";